import Img01 from '../image/cases/cases01.png';
import Img02 from '../image/cases/cases02.png';
import Img03 from '../image/cases/cases03.png';
import Img04 from '../image/cases/cases04.png';

export const caseData = (t) => [
  {
    id: 1,
    title: t('personal_blog_title'),
    image: Img01,
    description: t('personal_blog_description'),
    link: 'https://superlative-haupia-4a8528.netlify.app/#home',
  },
  {
    id: 2,
    title: t('planetarium_title'),
    image: Img02,
    description: t('planetarium_description'),
    link: 'https://ase.iqxpert.pro/',
  },
  {
    id: 3,
    title: t('consultancy_solution_title'),
    image: Img04,
    description: t('consultancy_solution_description'),
    link: 'https://dynamic-froyo-daa3f4.netlify.app/',
  },
  {
    id: 4,
    title: t('dashboard_srm_title'),
    image: Img03,
    description: t('dashboard_srm_description'),
    link: 'https://tiny-chebakia-ffb608.netlify.app/',
  },
];
